import React from 'react'

import * as CurrencyFormat from 'react-currency-format'
import { useHistory } from 'react-router-dom'

import { useStateValue } from '../HOC/StateProvider'
import { getBasketTotal } from '../../store/reducer'

import './Subtotal.scss'
import { toast } from 'react-toastify'

const Subtotal = () => {
  const history = useHistory()
  const { state, dispatch } = useStateValue()
  const { basket, user } = state

  const checkout = () => {
    if (user) return toast.info('Demo Checkout feature yet to be integrated')

    history.push('/login?redirectTo=checkout')
    toast.warn('Login to complete checkout')
  }

  return (
    <div className='subtotal'>
      <CurrencyFormat
        renderText={(value) => (
          <>
            <p>
              {/* Part of the homework */}
              Subtotal ({basket.length} items): <strong>{value}</strong>
            </p>
            <small className='subtotal__gift'>
              <input type='checkbox' /> This order contains a gift
            </small>
          </>
        )}
        decimalScale={2}
        value={getBasketTotal(basket)} // Part of the homework
        displayType={'text'}
        thousandSeparator={true}
        prefix={'$'}
      />

      <button onClick={checkout}>Proceed to Checkout</button>
    </div>
  )
}

export default Subtotal
